<div class="aside-hamburger-menu" (click)="mobBurgerMenuAction()">
    <span></span>
    <span></span>
    <span></span>
</div>
<div class="UNFAPP-newwdashbrd-lftnav-area" [ngClass]="mobMuenuStatus ? 'expend':''" (click)="closeBurgerMenu()">
    <span class="m-overlay"></span>

    <div class="UNFAPP-leftsidebarprofile-cont UNFAPP-d-hide" (click)="showMyProfile()">

        <img src="{{profileImagePath + profilePhoto}}" (error)="setDefaultPic()" alt="" class="UNFAPP-prfimg"
            *ngIf="!profilePic">

        <div class="UNFAPP-desccont">
            <h3 class="UNFAPP-desc-tittle">{{userData?.firstName + ' ' + userData?.lastName}}</h3>
            <p class="UNFAPP-desc-subtitle">Grade {{userData?.grade.name.replace('th' ,'')}}, {{displayExamName}}

            </p>
            <div class="UNFAPP-rightarow" (click)="showMyProfile()"></div>
        </div>
    </div>

    <ul class="UNFAPP-lftnav UNFAPP-topborder">
        <ng-container *ngFor="let tab of upperLeftsideNavigationMenu">
            <li (click)="navigateTo(tab.routeUrl, tab.module)">
                <a href="javascript:void(0)">
                    <img [class]="tab.class"
                        [src]="(tab.module == 'selfLearnV2' && !router.url.includes('my-library'))?tab?.activeIcon:tab?.nonactiveIcon"
                        alt="" />
                    <!-- <img *ngIf="tab?.menuName == 'LearnV2' && tab.menuName != 'dashboard'" [class]="tab.class"
                    [src]="getSourceImage(tab)"
                    alt="" /> -->
                    <span>{{tab?.menuName}}</span>
                </a>
            </li>
        </ng-container>

    </ul>
    <ul class="UNFAPP-lftnav">


        <li class="sidebar-menuitem">
            <li *ngIf="showBookMarks" (click)="navigateTo('/selfLearn-V2/my-library', 'my_bookmark')">
                <a href="javascript:void(0)">
    
                    <ng-container *ngIf="router.url.includes('/selfLearn-V2/my-library'); else notActiveBookmark">
                        <img src="assets/img/dashboard/active-menu-icons/bookmark-active-icon.svg" alt="" /> <span>My Bookmarks</span>
                    </ng-container>
                    <ng-template #notActiveBookmark>
                        <img src="assets/img/dashboard/menu-icons/bookmark-icon.svg" alt="" /> <span>My Bookmarks</span>
                    </ng-template>
                </a>
            </li>

        <ng-container *ngFor="let secondtab of secondNavigationLink">
        <li (click)="navigateTo(secondtab.routeUrl,secondtab.module )">
            <a href="javascript:void(0)">
                <img [src]="secondtab.allowedUrls.indexOf( router.url?.split('?')[0].split('/')[2]) !== -1 ?secondtab.activeIcon : secondtab.nonactiveIcon"
                    [class]="secondtab.class " alt="" /> <span> {{secondtab.menuName}}</span>


            </a>
        </li>
        </ng-container>


    </ul>
    <ul class="UNFAPP-lftnav UNFAPP-noborder">
        <li (click)="navigateTo('/dashboard/referral/', 'invite_earn')">
            <a href="javascript:void(0)">

                <ng-container *ngIf="router.url.includes('/referral'); else notActiveInviteEarn">
                    <img src="assets/img/dashboard/active-menu-icons/invite-active-icon.svg" alt="" /> <span>Invite &
                        Earn</span>
                </ng-container>
                <ng-template #notActiveInviteEarn>
                    <img src="assets/img/dashboard/menu-icons/invite-icon.svg" alt="" /> <span>Invite & Earn</span>
                </ng-template>
            </a>
        </li>

        <li (click)="navigateTo('/dashboard/contactus', 'contactus')">
            <a href="javascript:void(0)">
                <ng-container *ngIf="router.url.includes('/contactus'); else notActiveContactsus">
                    <img src="assets/img/dashboard/active-menu-icons/phone-yellow-icon.svg" alt="" /> <span>Contact
                        Us</span>
                </ng-container>
                <ng-template #notActiveContactsus>
                    <img src="assets/img/dashboard/menu-icons/contact-icon.svg" alt="" /> <span>Contact Us</span>
                </ng-template>
                <!-- <img src="assets/img/dashboard/menu-icons/contact-icon.svg" alt="" /> <span>Contact Us</span> -->
            </a>
        </li>
    </ul>

    <div class="UNFAPP-logoutcont UNFAPP-topborder UNFAPP-d-hide">
        <button class="dropdown-item" type="button" (click)="logout()">
            <img src="assets/img/logout-icon-dark.svg" alt="Logout">
            Logout
        </button>
    </div>

</div>